module.exports = __webpack_public_path__ + "static/media/ab_gauge_bg.f7f50781.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/meter/ab_gauge_bg.png
// module id = 268
// module chunks = 0